import { useMutation } from '@tanstack/react-query';

import { PricesRepository } from 'domain/repositories/IPricesRepository';
import { ID } from 'domain/types/ID';
import { useHookInjection } from 'application/hooks';

export const useCaseDeleteAssociation = () => {
  const { deleteAssociation } = useHookInjection<PricesRepository>(PricesRepository);
  const { mutateAsync } = useMutation<void, Error, { associationId: ID }>({
    mutationFn: deleteAssociation,
  });
  return {
    deleteAssociation: mutateAsync,
  };
};
